module.exports = __webpack_public_path__ + "static/img/Course.d3aa839.png";